import { render, staticRenderFns } from "./AddMiniGrid.vue?vue&type=template&id=76c31546&scoped=true"
import script from "./AddMiniGrid.vue?vue&type=script&lang=js"
export * from "./AddMiniGrid.vue?vue&type=script&lang=js"
import style0 from "./AddMiniGrid.vue?vue&type=style&index=0&id=76c31546&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76c31546",
  null
  
)

export default component.exports